<div [formGroup]="formGroup">

  <mat-checkbox
    [matTooltip]="tooltip"
    [matTooltipPosition]="tooltipPosition"
    [formControlName]="formCtrlName"
    [labelPosition]="labelPosition"
    [ngClass]="cssClasses"
    (change)="onChange.emit($event)"
  >
    <ng-content></ng-content>
  </mat-checkbox>
</div>
